import { ref, watch } from "vue";
import { Decimal } from "@/libs/decimal";
import { useAeppSdk } from "./aeppSdk";
import { storeToRefs } from "pinia";
import { useAccounts } from "@/stores";

let isInitialized = false;
let timer: NodeJS.Timer;

const aeBalance = ref<Decimal>(Decimal.ZERO);
const aeBalanceLoading = ref(true);
const aeBalanceLoaded = ref(false);

export function useAeBalance() {
  const { getAeSdk } = useAeppSdk();
  const { activeAccount } = storeToRefs(useAccounts());

  async function loadBalance() {
    aeBalanceLoading.value = true;
    const sdk = await getAeSdk();
    if (sdk && activeAccount.value) {
      const loadedBalance = await sdk.getBalance(activeAccount.value);
      aeBalance.value = Decimal.fromBigNumberString(loadedBalance);
    } else {
      aeBalance.value = Decimal.ZERO;
    }
    aeBalanceLoaded.value = true;
    aeBalanceLoading.value = false;
  }

  if (!isInitialized) {
    isInitialized = true;

    watch(
      activeAccount,
      (val, oldVal) => {
        if (val && val !== oldVal) {
          loadBalance();
          clearTimeout(timer);
          timer = setInterval(() => loadBalance(), 5000);
        }
      },
      { immediate: true }
    );
  }

  return {
    aeBalance,
    aeBalanceLoading,
    aeBalanceLoaded,
  };
}
